export const importExportHu = {
  import: {
    // Steps
    stepUpload: 'Feltöltés',
    stepMapping: 'Mezők társítása',
    stepPreview: 'Előnézet',
    stepResult: 'Eredmény',

    // Upload step
    title: '{entity} importálása',
    dropHere: 'Húzd ide a fájlt vagy kattints a tallózáshoz',
    supportedFormats: 'Támogatott formátumok: CSV, XLSX, XLS, ODS',
    noTemplate: 'Nem tudod milyen formátumban töltsd fel?',
    downloadTemplate: 'Sablon letöltése',
    emptyFile: 'A fájl nem tartalmaz adatokat',
    parseError: 'Hiba a fájl beolvasásakor',

    // Mapping step
    file: 'Fájl',
    rows: 'sor',
    targetField: 'Cél mező',
    sourceColumn: 'Forrás oszlop',
    required: 'Kötelező',
    noMapping: '— Nincs társítás —',
    back: 'Vissza',
    next: 'Előnézet',

    // Preview step
    validRows: 'Érvényes sorok',
    errorRows: 'Hibás sorok',
    totalRows: 'Összes sor',
    errors: 'Hibák',
    showingFirst: 'Megjelenítve: első 10 sor a {count} érvényes sorból',
    importRows: '{count} sor importálása',
    noValidRows: 'Nincs érvényes sor az importáláshoz',

    // Importing step
    importing: 'Importálás folyamatban...',
    importingWait: 'Kérlek várj, amíg a rekordok feldolgozásra kerülnek',

    // Result step
    success: 'Importálás sikeres!',
    completed: 'Importálás befejezve',
    resultSummary: '{success} sikeres, {failed} sikertelen',
    close: 'Bezárás',

    // Export
    export: 'Export',
    exportCSV: 'CSV formátum',
    exportExcel: 'Excel (XLSX)',
    noData: 'Nincs exportálható adat',
    exportSuccess: '{count} rekord exportálva ({format})',
    exportError: 'Hiba az exportálás során',

    // Import results
    importSuccess: '{count} rekord sikeresen importálva',
    importFailed: '{count} rekord importálása sikertelen',
    importError: 'Hiba az importálás során',

    // Entity names
    customers: 'Ügyfelek',
    suppliers: 'Beszállítók',
    products: 'Termékek',

    // Button labels with entity
    importButton: '{entity} import',
    exportButton: '{entity} export',
  },
};
